import { createAuthClientReact } from "@repo/auth/client-react";

export const authClient = createAuthClientReact({
  basePath: "/api/auth",
});
